// Put here values of colors manually due to portal light/dark mode trickiness
export const NotFoundPage = ({
	path: _path,
	variant = "auto",
}: {
	path: string
	variant?: "light" | "dark" | "auto"
}) => {
	const isDark = variant === "dark"
	const isAuto = variant === "auto"

	return (
		<main
			className={`grid h-screen place-items-center px-6 py-24 sm:py-32 lg:px-8 ${
				isDark
					? "bg-[#0F0F12]"
					: isAuto
						? "bg-white dark:bg-[#0F0F12]"
						: "bg-white"
			}`}
		>
			<div className="flex flex-col items-center text-center">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="64"
					height="64"
					viewBox="0 0 24 24"
					aria-hidden="true"
				>
					<g fill="none">
						<path
							d="M1 8.34944C1 7.31285 1 6.79455 1.15365 6.33311C1.28957 5.92492 1.5117 5.55074 1.80496 5.23595C2.13648 4.8801 2.59149 4.63191 3.50151 4.13554L7.26767 2.08127C8.82638 1.23107 9.60573 0.805964 10.2428 0.883876C10.7987 0.951865 11.3007 1.24983 11.6265 1.70532C12 2.22728 12 3.11503 12 4.89053V12.6506C12 13.6872 12 14.2054 11.8463 14.6669C11.7104 15.0751 11.4883 15.4493 11.195 15.764C10.8635 16.1199 10.4085 16.3681 9.49849 16.8645L5.73233 18.9187C4.17362 19.7689 3.39427 20.194 2.75721 20.1161C2.20129 20.0481 1.69935 19.7502 1.37346 19.2947C1 18.7727 1 17.885 1 16.1095V8.34944Z"
							fill="url(#notfound_app-stack_0)"
							mask="url(#notfound_app-stack_mask)"
						/>
						<path
							d="M1 8.34944C1 7.31285 1 6.79455 1.15365 6.33311C1.28957 5.92492 1.5117 5.55074 1.80496 5.23595C2.13648 4.8801 2.59149 4.63191 3.50151 4.13554L7.26767 2.08127C8.82638 1.23107 9.60573 0.805964 10.2428 0.883876C10.7987 0.951865 11.3007 1.24983 11.6265 1.70532C12 2.22728 12 3.11503 12 4.89053V12.6506C12 13.6872 12 14.2054 11.8463 14.6669C11.7104 15.0751 11.4883 15.4493 11.195 15.764C10.8635 16.1199 10.4085 16.3681 9.49849 16.8645L5.73233 18.9187C4.17362 19.7689 3.39427 20.194 2.75721 20.1161C2.20129 20.0481 1.69935 19.7502 1.37346 19.2947C1 18.7727 1 17.885 1 16.1095V8.34944Z"
							fill="url(#notfound_app-stack_0)"
							filter="url(#notfound_app-stack_filter)"
							clipPath="url(#notfound_app-stack_clip)"
						/>
						<path
							d="M6.5 9.84944C6.5 8.81285 6.5 8.29455 6.65365 7.83311C6.78957 7.42492 7.0117 7.05074 7.30496 6.73595C7.63648 6.3801 8.09149 6.13191 9.00151 5.63554L12.7677 3.58127C14.3264 2.73107 15.1057 2.30596 15.7428 2.38388C16.2987 2.45187 16.8007 2.74983 17.1265 3.20532C17.5 3.72728 17.5 4.61503 17.5 6.39053V14.1506C17.5 15.1872 17.5 15.7054 17.3463 16.1669C17.2104 16.5751 16.9883 16.9493 16.695 17.264C16.3635 17.6199 15.9085 17.8681 14.9985 18.3645L11.2323 20.4187C9.67362 21.2689 8.89427 21.694 8.25721 21.6161C7.70129 21.5481 7.19935 21.2502 6.87346 20.7947C6.5 20.2727 6.5 19.385 6.5 17.6095V9.84944Z"
							fill="url(#notfound_app-stack_1)"
						/>
						<path
							d="M15.7432 2.38348C16.2989 2.45155 16.8011 2.7495 17.127 3.20477C17.5004 3.72671 17.5 4.61505 17.5 6.39032V14.1501C17.5 15.1865 17.5002 15.7053 17.3467 16.1667L17.291 16.3181C17.1535 16.6672 16.9517 16.9881 16.6953 17.2634L16.5645 17.3932C16.3449 17.5931 16.0654 17.7693 15.6572 17.9997H14.1006L14.6396 17.7057C15.5951 17.1846 15.9176 16.9983 16.1465 16.7526C16.3663 16.5166 16.5329 16.2354 16.6348 15.9294C16.7407 15.6109 16.75 15.2382 16.75 14.1501V6.39032C16.75 5.48807 16.7488 4.86287 16.7061 4.39618C16.663 3.92695 16.5853 3.73729 16.5166 3.6413C16.3129 3.35677 15.9987 3.1701 15.6514 3.12762C15.5341 3.11341 15.3305 3.13621 14.8984 3.32294C14.4683 3.50884 13.919 3.80693 13.127 4.23895L9.36035 6.29364C8.40497 6.81476 8.08241 7.00114 7.85352 7.24677C7.63365 7.48278 7.46718 7.76398 7.36523 8.07001C7.25922 8.38856 7.25 8.7611 7.25 9.8493V17.6091C7.25 17.7997 7.25147 17.9782 7.25195 18.1452C6.96284 18.2619 6.70849 18.445 6.50488 18.6745C6.50072 18.36 6.5 18.0067 6.5 17.6091V9.8493C6.5 8.81291 6.49969 8.2941 6.65332 7.8327C6.77227 7.47559 6.95742 7.14418 7.19824 6.85614L7.30469 6.73602C7.55334 6.46917 7.87195 6.2624 8.39941 5.96649L9.00195 5.63544L12.7676 3.58075C14.3262 2.73061 15.1061 2.30559 15.7432 2.38348Z"
							fill="url(#notfound_app-stack_2)"
						/>
						<path
							d="M12 11.3494C12 10.3128 12 9.79455 12.1537 9.33311C12.2896 8.92492 12.5117 8.55074 12.805 8.23595C13.1365 7.8801 13.5915 7.63191 14.5015 7.13554L18.2677 5.08127C19.8264 4.23107 20.6057 3.80596 21.2428 3.88388C21.7987 3.95187 22.3007 4.24983 22.6265 4.70532C23 5.22728 23 6.11503 23 7.89053V15.6506C23 16.6872 23 17.2054 22.8463 17.6669C22.7104 18.0751 22.4883 18.4493 22.195 18.764C21.8635 19.1199 21.4085 19.3681 20.4985 19.8645L16.7323 21.9187C15.1736 22.7689 14.3943 23.194 13.7572 23.1161C13.2013 23.0481 12.6993 22.7502 12.3735 22.2947C12 21.7727 12 20.885 12 19.1095V11.3494Z"
							fill="url(#notfound_app-stack_3)"
						/>
						<defs>
							<linearGradient
								id="notfound_app-stack_0"
								x1="6.5"
								y1="-.5"
								x2="6.5"
								y2="21.5"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#575757" />
								<stop offset="1" stopColor="#151515" />
							</linearGradient>
							<linearGradient
								id="notfound_app-stack_1"
								x1="12"
								y1="1"
								x2="12"
								y2="23"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#E3E3E5" stopOpacity=".6" />
								<stop offset="1" stopColor="#BBBBC0" stopOpacity=".6" />
							</linearGradient>
							<linearGradient
								id="notfound_app-stack_2"
								x1="12"
								y1="2.375"
								x2="12"
								y2="17.5"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#fff" stopOpacity="1" />
								<stop offset="1" stopColor="#fff" stopOpacity="0" />
							</linearGradient>
							<linearGradient
								id="notfound_app-stack_3"
								x1="17.5"
								y1="2.5"
								x2="17.5"
								y2="24.5"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#575757" />
								<stop offset="1" stopColor="#151515" />
							</linearGradient>
							<filter
								id="notfound_app-stack_filter"
								x="-100%"
								y="-100%"
								width="400%"
								height="400%"
								filterUnits="objectBoundingBox"
								primitiveUnits="userSpaceOnUse"
							>
								<feGaussianBlur
									stdDeviation="2"
									x="0%"
									y="0%"
									width="100%"
									height="100%"
									in="SourceGraphic"
									edgeMode="none"
									result="blur"
								/>
							</filter>
							<clipPath id="notfound_app-stack_clip">
								<path d="M6.5 9.84944C6.5 8.81285 6.5 8.29455 6.65365 7.83311C6.78957 7.42492 7.0117 7.05074 7.30496 6.73595C7.63648 6.3801 8.09149 6.13191 9.00151 5.63554L12.7677 3.58127C14.3264 2.73107 15.1057 2.30596 15.7428 2.38388C16.2987 2.45187 16.8007 2.74983 17.1265 3.20532C17.5 3.72728 17.5 4.61503 17.5 6.39053V14.1506C17.5 15.1872 17.5 15.7054 17.3463 16.1669C17.2104 16.5751 16.9883 16.9493 16.695 17.264C16.3635 17.6199 15.9085 17.8681 14.9985 18.3645L11.2323 20.4187C9.67362 21.2689 8.89427 21.694 8.25721 21.6161C7.70129 21.5481 7.19935 21.2502 6.87346 20.7947C6.5 20.2727 6.5 19.385 6.5 17.6095V9.84944Z" />
							</clipPath>
							<mask id="notfound_app-stack_mask">
								<rect width="100%" height="100%" fill="#FFF" />
								<path
									d="M6.5 9.84944C6.5 8.81285 6.5 8.29455 6.65365 7.83311C6.78957 7.42492 7.0117 7.05074 7.30496 6.73595C7.63648 6.3801 8.09149 6.13191 9.00151 5.63554L12.7677 3.58127C14.3264 2.73107 15.1057 2.30596 15.7428 2.38388C16.2987 2.45187 16.8007 2.74983 17.1265 3.20532C17.5 3.72728 17.5 4.61503 17.5 6.39053V14.1506C17.5 15.1872 17.5 15.7054 17.3463 16.1669C17.2104 16.5751 16.9883 16.9493 16.695 17.264C16.3635 17.6199 15.9085 17.8681 14.9985 18.3645L11.2323 20.4187C9.67362 21.2689 8.89427 21.694 8.25721 21.6161C7.70129 21.5481 7.19935 21.2502 6.87346 20.7947C6.5 20.2727 6.5 19.385 6.5 17.6095V9.84944Z"
									fill="#000"
								/>
							</mask>
						</defs>
					</g>
				</svg>
				<h1
					className={`mt-5 text-xl font-semibold tracking-tight ${
						isDark
							? "text-gray-50"
							: isAuto
								? "text-gray-900 dark:text-gray-50"
								: "text-gray-900"
					}`}
				>
					Page not found
				</h1>
				<p
					className={`mt-2 max-w-sm text-sm leading-6 ${
						isDark
							? "text-gray-400"
							: isAuto
								? "text-gray-500 dark:text-gray-400"
								: "text-gray-500"
					}`}
				>
					Sorry, we couldn&apos;t find the page you&apos;re looking for.
				</p>
				<a
					href="https://www.productlane.com"
					className={`mt-6 inline-flex items-center rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
						isDark
							? "border-white/10 bg-white/10 text-gray-100 hover:bg-white/15"
							: isAuto
								? "border-transparent bg-gray-900 text-white hover:bg-gray-800 dark:border-white/10 dark:bg-white/10 dark:text-gray-100 dark:hover:bg-white/15"
								: "border-transparent bg-gray-900 text-white hover:bg-gray-800"
					}`}
				>
					Go back home
				</a>
			</div>
		</main>
	)
}
